import { RequestInstance } from "../../../utils/request";

export const contractBillPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/bill/page",
});

export const contractWalletUseFlowPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/wallet/use/flow/page",
});

export const deviceDaySettPage = new RequestInstance({
  method: "get",
  url: "/v2/device/day/settlement/page",
});

export const tenantPage = new RequestInstance({
  method: "get",
  url: "/v2/tenant/page",
});

export const contractPage = new RequestInstance({
  method: "get",
  url: "/v2/contract/page",
});
